"use client"

import {ThemeProvider as NextThemesProvider} from "next-themes"
import React from "react";

type ThemeProviderProps = React.ComponentProps<typeof NextThemesProvider>

export function ThemeProvider({children, ...props}: ThemeProviderProps) {
    return (
        <NextThemesProvider
            attribute="class"
            defaultTheme="light"
            enableSystem
            {...props}
        >
            {children}
        </NextThemesProvider>
    );
}
